import React from 'react';
import css from './RidingDisciplinesLevels.css';
import { desiredLevelsSearchSchemaParam } from '../../containers/SearchPage/SearchPage.helpers';
import { compose } from 'redux';
import { injectIntl } from 'react-intl';
import { getCenterFromBounds } from '../../util/location';
import {
    EXPERIENCE_LEVEL_ADVANCED,
    EXPERIENCE_LEVEL_BEGINNER,
    EXPERIENCE_LEVEL_EXPERIENCED,
    EXPERIENCE_LEVEL_VERY_EXPERIENCED,
} from '../../marketplace-custom-config';

const RidingDisciplinesLevels = props => {
    const { address, bounds, intl } = props;
    const origin = getCenterFromBounds(bounds);

    const levelsData = [
        {
            levelTitle: intl.formatMessage({
                id: `RidingDisciplinesLevels.title.${EXPERIENCE_LEVEL_BEGINNER}`,
            }),
            disciplinesLevels: EXPERIENCE_LEVEL_BEGINNER,
        },
        {
            levelTitle: intl.formatMessage({
                id: `RidingDisciplinesLevels.title.${EXPERIENCE_LEVEL_ADVANCED}`,
            }),
            disciplinesLevels: EXPERIENCE_LEVEL_ADVANCED,
        },
        {
            levelTitle: intl.formatMessage({
                id: `RidingDisciplinesLevels.title.${EXPERIENCE_LEVEL_EXPERIENCED}`,
            }),
            disciplinesLevels: EXPERIENCE_LEVEL_EXPERIENCED,
        },
        {
            levelTitle: intl.formatMessage({
                id: `RidingDisciplinesLevels.title.${EXPERIENCE_LEVEL_VERY_EXPERIENCED}`,
            }),
            disciplinesLevels: EXPERIENCE_LEVEL_VERY_EXPERIENCED,
        },
    ];

    return (
        <div className={css.tileGrid}>
            {levelsData.map((level, index) => {
                const link = `/s?address=${address}&bounds=${bounds}&origin=${origin}&listingType=horse&${desiredLevelsSearchSchemaParam}=${level.disciplinesLevels}`;
                return (
                    <a href={link} className={css.tile} key={index}>
                        <h3 className={css.heading}>
                            {intl.formatMessage({
                                id: 'RidingDisciplinesLevels.ridingShare.title',
                            })}{' '}
                            <br className={css.pageTitleBreak} />
                            <span className={css.levelTitleColor}>{level.levelTitle}</span>
                        </h3>
                    </a>
                );
            })}
        </div>
    );
};

export default compose(injectIntl)(RidingDisciplinesLevels);
